// Thanh hành động dính đáy cho form dài trên điện thoại (tạo đơn, thêm sản phẩm): nút chính luôn trong
// tầm tay, không phải cuộn xuống cuối trang. Nằm trên thanh tab / dock (≈ 80px + vùng an toàn).
// Chỉ hiện ở chế độ mobile — máy tính dùng nút trong cột bên phải như cũ.

import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function MobileActionBar({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      data-slot="action-bar"
      className={cn(
        'desktop:hidden sticky bottom-[calc(5.5rem+env(safe-area-inset-bottom,0px))] z-30 mt-3',
        'flex items-center gap-3 rounded-2xl border border-rule bg-raise/95 p-2.5 shadow-overlay backdrop-blur-md',
        className,
      )}
    >
      {children}
    </div>
  )
}
